export const supportEmail = 'support@fanconnect.tv';
